import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoItsFor() {
  const forWho = ['Jóvenes profesionales y estudiantes con mentes hiperactivas que no se detienen.', 'Personas que sienten ansiedad o palpitaciones leves al momento de acostarse.', 'Quienes calculan obsesivamente las horas de sueño que les quedan durante la madrugada.', 'Cualquier persona que se despierta a mitad de la noche y no puede volver a conciliar el sueño.'];
  const notForWho = ["Personas que buscan una solución 'mágica' sin estar dispuestas a mojar su cuello con agua fría o cambiar su respiración.", 'Casos médicos de apnea del sueño obstructiva que requieren maquinaria médica.', 'Personas que prefieren depender de fármacos pesados en lugar de entrenar su propio sistema nervioso.'];
  return <section className="py-16 md:py-24 bg-slate-900" data-id="element-199">
      <div className="max-w-5xl mx-auto px-4" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-202">
            ¿Es este protocolo para ti?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-203">
          {/* Para Quién Es */}
          <div className="bg-slate-800/80 rounded-2xl p-8 border border-green-500/20" data-id="element-204">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-205">
              <div className="bg-green-500/20 p-2 rounded-full" data-id="element-206">
                <CheckIcon className="w-6 h-6 text-green-400" data-id="element-207" />
              </div>
              Para quién SÍ es
            </h3>
            <ul className="space-y-4" data-id="element-208">
              {forWho.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-209">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-210" />
                  <span className="text-slate-300" data-id="element-211">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para Quién No Es */}
          <div className="bg-slate-800/80 rounded-2xl p-8 border border-red-500/20" data-id="element-212">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-213">
              <div className="bg-red-500/20 p-2 rounded-full" data-id="element-214">
                <XIcon className="w-6 h-6 text-red-400" data-id="element-215" />
              </div>
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-216">
              {notForWho.map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-217">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-218" />
                  <span className="text-slate-300" data-id="element-219">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}